import axios from 'axios'

interface ValidationError {
  [key: string]: any
}

export interface APIError {
  message: string | undefined
  status: number | undefined
  errors?: ValidationError[]
  raw: Error
}

const apiClient = axios.create({
  baseURL: 'https://madefor.github.io/postal-code-api/api/v1',
  timeout: 15 * 1000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    // 'X-Requested-With': 'XMLHttpRequest'
  },
})

apiClient.interceptors.response.use(
  (res) => res.data,
  (error) => error
)

export const registerGlobalErrorHandler = (
  handler: (error: APIError) => Promise<any>
) => {
  apiClient.interceptors.response.use((res) => res, handler)
}

export default apiClient
